import type { SVGProps } from 'react';

export const EditNotAllowed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'edit not allowed'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill="#3A4152" transform="translate(0, 0.1333)">
        <path d="M17.8666667,3.73333333 L25.4666667,11.3333333 L24.4,12.4 C23.8666667,12.2666667 23.2,12.2666667 22.6666667,12.2666667 L21.7333333,12.2666667 L22.6666667,11.3333333 L20.9333333,9.6 L8.4,22.1333333 C8.93333333,22.8 9.33333333,23.4666667 9.73333333,24.2666667 L12.2666667,21.7333333 L12.2666667,22.6666667 C12.2666667,23.2 12.4,23.8666667 12.4,24.4 L10.1333333,26.6666667 L0,29.2 L2.53333333,19.0666667 L17.8666667,3.73333333 Z M4,21.0666667 L3.06666667,25.3333333 C3.46666667,25.6 3.73333333,25.8666667 4,26.2666667 L8.13333333,25.2 C7.33333333,23.3333333 5.86666667,21.8666667 4,21.0666667 Z M18,6.4 L5.06666667,19.3333333 C5.86666667,19.7333333 6.53333333,20.1333333 7.2,20.6666667 L19.7333333,8.13333333 L18,6.4 Z M22.2666667,0 C26,0.533333333 28.8,3.33333333 29.3333333,7.06666667 L29.3333333,7.46666667 L26.2666667,10.5333333 L18.6666667,2.93333333 L21.7333333,0 Z M22.2666667,1.86666667 L21.3333333,2.8 L26.2666667,7.73333333 L27.2,6.8 C26.6666667,4.26666667 24.6666667,2.4 22.2666667,1.86666667 Z" />
      </g>
      <g
        fill="#D82F2F"
        fillRule="nonzero"
        transform="translate(13.8667, 13.8667)"
      >
        <path d="M8.93333333,0 C4,0 0,4 0,8.93333333 C0,13.8666667 4,17.8666667 8.93333333,17.8666667 C13.8666667,17.8666667 17.8666667,13.8666667 17.8666667,8.93333333 C17.8666667,4 13.8666667,0 8.93333333,0 Z M1.86666667,8.93333333 C1.86666667,7.33333333 2.4,6 3.2,4.8 L13.0666667,14.6666667 C11.8666667,15.4666667 10.5333333,16 8.93333333,16 C5.06666667,16 1.86666667,12.8 1.86666667,8.93333333 Z M14.4,13.3333333 L4.53333333,3.46666667 C5.73333333,2.53333333 7.33333333,1.86666667 8.93333333,1.86666667 C12.8,1.86666667 16,5.06666667 16,8.93333333 C16,10.6666667 15.4666667,12.1333333 14.4,13.3333333 Z" />
      </g>
    </g>
  </svg>
);
